import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useCallback } from 'react'

export const useOtherUserProfile = () => {
  const { updateModal } = useYoloModal()

  const showOtherUserProfile = useCallback(
    (address: string, username: string, avatar: string) => {
      const OTHER_USER_PROFILE_OBJ = {
        show: true,
        id: 'otherUserProfile',
        props: {
          address,
          username,
          avatar,
        },
      }
      updateModal(OTHER_USER_PROFILE_OBJ)
    },
    [updateModal],
  )
  return { showOtherUserProfile }
}
